import "./BaseTextInput_module.css";
const BaseTextInput_module = {
    wrapper: "wrapper__a58464749a6faa0c",
    control: "control__a58464749a6faa0c",
    fakeControl: "fakeControl__a58464749a6faa0c",
    placeholder: "placeholder__a58464749a6faa0c",
    disabled: "disabled__a58464749a6faa0c",
    readOnly: "readOnly__a58464749a6faa0c"
};
export { BaseTextInput_module as default };
